<template>
  <div class="social">
    <div
      v-for="network in networksWithUrls"
      :key="network.id"
      class="social__icon"
    >
      {{ network.name ? network.name.slice(0,2) : '' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentSocial',

  props: [
    'obj'
  ],

  computed: {
    networksWithUrls() {
      return this.obj.networks.filter(network => this.obj.attributes[`social.${network.id}.url`].value)
    }
  }
}
</script>

<style scoped>
  .social {
    display: flex;
    padding: 10px;
    justify-content: center;

    border: dotted 1px #CCC;
  }

  .social__icon {
    padding: 10px;
    width: 40px;
    height: 40px;
    margin-right: 10px;

    background: #CCC;
    border-radius: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
  }
</style>
